import { Group } from '../interfaces';
import { Switch } from '../widgets/beauty/input/Switch';
import { Checkbox } from '../widgets/beauty/input';
import templateService from '../../services/template-service';
import DialogComponent, { DialogProps } from '../widgets/dialog/DialogComponent';
import timeUtils from '../../utils/time-utils';

import './style';

interface Props extends DialogProps {
  group: Group;
  skipConfirm?: boolean;
  askRecursive?: boolean;
}

export default class ChooseTemplateDialog extends DialogComponent<Props> {

  state = {
    templates: [],
    confirm: false,
    selected: null,
    recursive: false,
    min1: true,
    max1: true,
    minPhone: true,
    maxPhone: true,
    calibrate: true,
    savePeriod: true,
    alarmPeriod: true,
    alarmActive: true,
    location: true,
    timeZone: true,
    calendarType: true
  }

  render() {
    const { confirm, selected, templates } = this.state;

    return (
      <div className="choose-template-component">
        {this.renderTitle()}
        {confirm ? (this.renderConfirm()) :
          selected ? (this.renderSwitches()) : (
            <ul className="templates-list">
              {templates.map((t: any) => (
                <li
                  key={t._id}
                  onClick={this.handleTemplateClicked.bind(this, t._id)}>{t.name}</li>
              ))}
            </ul>
          )
        }
        {(!confirm && !selected) ? (
          <div className="text-center text-desc mt-3 pt-2" style={{ borderTop: '1px solid #ddd' }}>
            برای درج و یا ویرایش الگوها به
            <a href="/dashboard/templates" className="success-link"> این صفحه </a>
            مراجعه کنید
          </div>
        ) : ''}
      </div>
    );
  }

  renderTitle = () => {
    const text = this.getTitleText();
    return (
      <div className="dialog-title">
        <span className="close-btn" onClick={this.close}>
          <i className="fas fa-times"></i>
        </span>
        <span className="title-text">{text}</span>
        {!this.state.selected ? '' : (
          <span className="back-btn" onClick={this.handleBackButtonClicked}>
            <i className="fas fa-arrow-left"></i>
          </span>
        )}
      </div>
    );
  }


  renderSwitches = () => {
    const state = this.state;
    const props = this.props;
    const template = state.templates.find(t => t._id === this.state.selected);
    const location = template.location ?? {};

    return (
      <div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">Min: </span>
            <span className="col">{template.min1}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.min1} onChange={this.handleOptionChanged.bind(this, 'min1')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">Max: </span>
            <span className="col">{template.max1}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.max1} onChange={this.handleOptionChanged.bind(this, 'max1')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">MinPhone: </span>
            <span className="col">{template.minPhone}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.minPhone} onChange={this.handleOptionChanged.bind(this, 'minPhone')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">MaxPhone: </span>
            <span className="col">{template.maxPhone}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.maxPhone} onChange={this.handleOptionChanged.bind(this, 'maxPhone')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">Calibrate:</span>
            <span className="col">{template.calibrate}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.calibrate} onChange={this.handleOptionChanged.bind(this, 'calibrate')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">Timezone:</span>
            <span className="col">{template.timeZone}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.timeZone} onChange={this.handleOptionChanged.bind(this, 'timeZone')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">نوع تقویم:</span>
            <span className="col">{timeUtils.getCalendarTextByLetter(template.calendarType)}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.calendarType} onChange={this.handleOptionChanged.bind(this, 'calendarType')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">ثبت هشدار و اطلاع رسانی:</span>
            <span className="col">{template.alarmActive === 1 ? 'فعال' : 'غیرفعال'}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.alarmActive} onChange={this.handleOptionChanged.bind(this, 'alarmActive')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">دوره ذخیره سازی:</span>
            <span className="col">{template.savePeriod}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.savePeriod} onChange={this.handleOptionChanged.bind(this, 'savePeriod')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">دوره اعلام هشدار:</span>
            <span className="col">{template.alarmPeriod}</span>
          </div>
          <div className="col-3">
            <Switch checked={state.alarmPeriod} onChange={this.handleOptionChanged.bind(this, 'alarmPeriod')} />
          </div>
        </div>
        <div className="row row-item">
          <div className="col-9">
            <span className="col">مکان سنسور:</span>
            {location.lng ? (<span className="col">{location.lng ?? ''} {location.lat ?? ''}</span>) : <span className="col">تعیین نشده</span>}
          </div>
          <div className="col-3">
            <Switch checked={state.location} onChange={this.handleOptionChanged.bind(this, 'location')} />
          </div>
        </div>
        {props.askRecursive === false ? '' : (
          <div className="row mt-3">
            <div className="col-12 rtl">
              <Checkbox
                text="تنظیمات روی سنسور های همه گروه های زیر مجموعه این گروه نیز اعمال شود"
                checked={state.recursive}
                onChange={this.handleOptionChanged.bind(this, 'recursive')}
              />
            </div>
          </div>
        )}
        <button
          className="btn btn-primary btn-submit"
          onClick={this.handleSubmitTemplate}>تایید تنظیمات</button>
      </div>
    );
  }

  renderConfirm = () => {
    return (
      <div>
        <div className="d-flex mt-2 justify-content-end">
          <button
            onClick={this.handleBackButtonClicked}
            className="ant-btn ant-btn-lg ml-2">خیر</button>
          <button
            onClick={this.handleConfirmClicked}
            className="ant-btn ant-btn-lg ant-btn-primary">اعمال تنظیمات</button>
        </div>
      </div>
    );
  }

  componentDidMount = async () => {
    try {
      const templates = await templateService.fetch();
      this.setState({ templates });
    }
    catch (e) {
      console.error(e);
    }
  }

  private handleBackButtonClicked = () => {
    const { confirm } = this.state;
    if (confirm) {
      return this.setState({ confirm: false });
    }
    this.setState({ selected: null });
  }

  private handleTemplateClicked = (id: string) => {
    this.setState({ selected: id });
  }

  private handleOptionChanged = (key: string) => {
    const value = this.state[key];
    this.setState({ [key]: !value });
  }

  private handleSubmitTemplate = async () => {
    if (!this.props.skipConfirm) {
      return this.setState({ confirm: true });
    }
    return this.handleConfirmClicked();
  }

  private handleConfirmClicked = () => {
    const { selected: templateId, recursive } = this.state;
    const fields = this.extractFields();
    this.resolve({
      fields,
      recursive,
      templateId
    });
    this.close();
  }

  private getTitleText = () => {
    const { confirm, selected } = this.state;
    if (!selected) {
      return 'الگوی خود را انتخاب کنید';
    }
    if (confirm) {
      return `آیا از اعمال تنظیمات بر روی گروه \`${this.props.group.name}\` اطمینان دارید؟`;
    }
    return 'فیلدهای مورد نیاز جهت اعمال تغییرات را انتخاب کنید';
  }

  private extractFields = () => {
    const { confirm, templates, selected, recursive, ...rest } = this.state;
    let fields = [];
    for (const key in rest) {
      if (Object.prototype.hasOwnProperty.call(rest, key)) {
        const value = rest[key];
        if (value === true) {
          fields.push(key);
        }
      }
    }
    return fields;
  }

}
